__webpack_require__.p = "https://app.itdex.net/";